import React from "react";
import "./CertificateGroupingCommon.scss";
import CertificateGroupingListCommon from "../../features/CertificateGroupingListCommon/CertificateGroupingListCommon";

const CertificateGroupingCommon = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListCommon />
    </div>
  );
};

export default CertificateGroupingCommon;
